import {filter, Subject} from 'rxjs';

const subject = new Subject<{channel: string; type: string; payload: any}>();

export const mc = {
  subscribe(channel: string, type: string, handler: (payload: any) => void) {
    const subscription = subject.pipe(filter((o) => o.channel === channel && o.type === type)).subscribe((o) => handler(o.payload));
    return function () {
      subscription.unsubscribe();
    };
  },

  send(channel, type, payload = {}) {
    subject.next({channel, type, payload});
  },
};
